import { useMutation, useQuery } from "@tanstack/react-query";
import { financialSaleExcel, getSaleDetail } from "Services/Reporting";
import AccordionTable from "./components/AccordionTable";
import { Button, PageTemplate, Table } from "components";
import { useParams } from "react-router-dom";
import { ResponseHandler } from "components";
import { addCamma } from "utils/helpers";
import { ReactComponent as Download } from "assets/icons/cloud-download.svg";
import { v4 as uuidv4 } from "uuid";
import styles from "./style.module.scss";
import { useMemo } from "react";

const SaleDetail = () => {
    const { vendorID, periodID } = useParams<{
        vendorID: string;
        periodID: string;
    }>();

    const { data, isFetching, isError } = useQuery(
        ["financialSale", periodID, vendorID],
        () => getSaleDetail({ periodID, vendorID })
    );

    const { mutate: mutateExportExcel } = useMutation(
        ["financial-sale-excel"],
        financialSaleExcel,
        {
            onSuccess: (res) => {
                const link = document.createElement("a");
                link.href = res.data;
                link.setAttribute("download", "financial-sale-excel");
                document.body.appendChild(link);
                link.click();
                link.parentNode?.removeChild(link);
            },
        }
    );

    const { summary, ...tablesData } = data?.data || {};

    const updatedSummary = useMemo(() => {
        return summary?.map((item: any) => ({
            ...item,
            id: uuidv4(),
        }));
    }, [summary]);

    const terms: any = {
        b2c: "اسنپ‌فود",
        b2b: "فروش سازمانی",
        offline: "فروش آفلاین",
        total: "مجموع",
    };
    const SumTableColumns = [
        {
            Header: "بستر فروش",
            accessor: "sales_channel",
            Cell: (props: any) => terms[props.row.original?.sales_channel],
        },
        {
            Header: "شامل کمیسیون",
            accessor: "total_with_calc_quantity",
        },
        {
            Header: "شامل کمیسیون (ریال)",
            accessor: "total_with_calc_amount",
            Cell: (props: any) => addCamma(props.value),
        },
        {
            Header: "تامین شده توسط کیچن",
            accessor: "total_no_calc_with_supplied_quantity",
        },
        {
            Header: " تامین شده توسط کیچن (ریال)",
            accessor: "total_no_calc_with_supplied_amount",
            Cell: (props: any) => addCamma(props.value),
        },
        {
            Header: "سایر",
            accessor: "total_no_calc_no_supplied_quantity",
        },
        {
            Header: "سایر (ریال)",
            accessor: "total_no_calc_no_supplied_amount",
            Cell: (props: any) => addCamma(props.value),
        },
    ];

    const COLUMNS = [
        {
            Header: "شعبه",
            accessor: "branch_title",
        },
        {
            Header: "شامل کمیسیون",
            accessor: "total_with_calc_quantity",
        },
        {
            Header: "شامل کمیسیون (ریال)",
            accessor: "total_with_calc_amount",
            Cell: (props: any) => addCamma(props.value),
        },
        {
            Header: "تامین شده توسط کیچن",
            accessor: "total_no_calc_with_supplied_quantity",
        },
        {
            Header: " تامین شده توسط کیچن (ریال)",
            accessor: "total_no_calc_with_supplied_amount",
            Cell: (props: any) => addCamma(props.value),
        },
        {
            Header: "سایر",
            accessor: "total_no_calc_no_supplied_quantity",
        },
        {
            Header: "سایر (ریال)",
            accessor: "total_no_calc_no_supplied_amount",
            Cell: (props: any) => addCamma(props.value),
        },
    ];

    const saleReports = {
        b2c: {
            title: "بستر فروش اسنپ‌فود",
            active: false,
        },
        b2b: {
            title: "بستر فروش سازمانی",
            active: false,
        },
        offline: {
            title: "بستر فروش آفلاین",
            active: false,
        },
        total: {
            title: "مجموع",
            active: false,
        },
    };

    return (
        <ResponseHandler loading={isFetching} error={isError}>
            <PageTemplate
                groupName="گزارشات"
                title={"دوره مالی"}
                listOfTitles={["جزییات فروش"]}
                customStylePageTemplate={styles.customStylePageTemplate}
            >
                <div className={styles.exportExcalBtn}>
                    <Button
                        btnText={"خروجی اکسل"}
                        className="is-green bordered half-height"
                        handleClick={() =>
                            mutateExportExcel({ periodID, vendorID })
                        }
                        btnIcon={<Download className="mr-2" />}
                    />
                </div>
                <div className={styles.sumFinancialContainer}>
                    <Table
                        columns={SumTableColumns}
                        data={updatedSummary || []}
                        className={styles.sumFinancialTable}
                    />
                </div>
                {tablesData &&
                    Object.entries(tablesData)?.map(([key, value]: any) => {
                        return (
                            <AccordionTable
                                report={
                                    saleReports[key as keyof typeof saleReports]
                                }
                                key={key}
                                tableComponent={
                                    <div className={styles.tableContainer}>
                                        <div className={styles.tableContent}>
                                            <Table
                                                columns={COLUMNS}
                                                data={value}
                                                className={
                                                    styles.financialTable
                                                }
                                            />
                                        </div>
                                    </div>
                                }
                            />
                        );
                    })}
            </PageTemplate>
        </ResponseHandler>
    );
};

export default SaleDetail;
